import {ApiBase} from "@/src/model/ApiBase";
import {GRAPH_API_TYPE} from "@/src/model/apiTypes";

export class GraphApi extends ApiBase {
    async [GRAPH_API_TYPE.GET_GRAPH]({graphId}) {
        return await this.httpGet(`graphs/${graphId}/`)
    }

    async [GRAPH_API_TYPE.ADD_GRAPH]({spaceId, name, container_name, pac_project_key, blob_name, case_column, timestamp_column, activity_column, sorting_column, role_column, definition}) {
        return await this.httpPost(`workspaces/${spaceId}/graphs/`, {
            name,
            container_name,
            blob_name,
            case_column,
            timestamp_column,
            activity_column,
            sorting_column,
            role_column,
            pac_project_key,
            definition
        })
    }

    async [GRAPH_API_TYPE.CLEAN_UP_RESULTS]({graphId, data}) {
        return await this.httpPost(`graphs/${graphId}/cleanup/`, data)
    }

    async [GRAPH_API_TYPE.PUBLISH_GRAPH]({graphId, description}) {
        return await this.httpPut(`graphs/${graphId}/publish/`, {description});
    }

    async [GRAPH_API_TYPE.UPDATE_GRAPH]({graphId, data}) {
        return await this.httpPatch(`graphs/${graphId}/`, data)
    }

    async [GRAPH_API_TYPE.DELETE_GRAPH]({graphId}) {
        return await this.httpDelete(`graphs/${graphId}/`)
    }

    async [GRAPH_API_TYPE.DELETE_GRAPHS](graphIds) {
        return await this.httpPost(`graphs/delete/`, {graph_ids: graphIds})
    }

    async [GRAPH_API_TYPE.RUN_JOB]({graphId}) {
        return await this.httpGet(`graphs/${graphId}/job/run/`)
    }

    async [GRAPH_API_TYPE.RUN_JOBS](graphIds) {
        return await this.httpPost('graphs/job/run/', {graph_ids: graphIds})
    }

    async [GRAPH_API_TYPE.CANCEL_JOB]({graphId}) {
        return await this.httpPost(`graphs/${graphId}/job_executions/cancel/`)
    }

    async [GRAPH_API_TYPE.LAST_JOB_EXECUTION]({graphId}) {
        return await this.httpGet(`graphs/${graphId}/job/job_executions/?count=1&logs`)
    }

    async [GRAPH_API_TYPE.JOB_EXECUTIONS]({graphId, count, from}) {
        return await this.httpGet(`graphs/${graphId}/job/job_executions/?count=${count}&from=${from}&logs`)
    }

    async [GRAPH_API_TYPE.JOB_EXECUTION_LOGS]({graphId, jobExecutionId}) {
        return await this.httpGet(`graphs/${graphId}/job/job_executions/${jobExecutionId}/logs`)
    }

    async [GRAPH_API_TYPE.JOB_EXECUTION_COUNT]({graphId}) {
        return await this.httpGet(`graphs/${graphId}/job/job_executions/count/`)
    }

    async [GRAPH_API_TYPE.GET_VERSIONS]({graphId}) {
        return await this.httpGet(`graphs/${graphId}/versions/`)
    }

    async [GRAPH_API_TYPE.RESTORE_VERSION]({graphId, versionId}) {
        return await this.httpPut(`graphs/${graphId}/versions/${versionId}/restore/`);
    }

    async [GRAPH_API_TYPE.GET_PERMISSIONS]({graphId}) {
        return await this.httpGet(`graphs/${graphId}/permissions/`)
    }

    async [GRAPH_API_TYPE.GET_USER_PERMISSIONS]({graphId}) {
        return await this.httpGet(`graphs/${graphId}/permissions/user/`)
    }

    async [GRAPH_API_TYPE.UPDATE_PERMISSIONS]({spaceId, graphId, data}) {
        return await this.httpPost(`graphs/${graphId}/permissions/`, data)
    }

    async [GRAPH_API_TYPE.LOCK_GRAPH]({graphId}) {
        return await this.httpPost(`graphs/${graphId}/lock/`)
    }

    async [GRAPH_API_TYPE.UNLOCK_GRAPH]({graphId}) {
        return await this.httpPost(`graphs/${graphId}/lock/`, {unlock: true})
    }

    async [GRAPH_API_TYPE.GET_LOCK]({graphId}) {
        return await this.httpGet(`graphs/${graphId}/lock/`)
    }

    async [GRAPH_API_TYPE.GET_RESULTS]({spaceId}) {
        return await this.httpGet(`workspaces/${spaceId}/results/`)
    }

    async [GRAPH_API_TYPE.IMPORT_BPMN]({workspaceId, formData}) {
        return await this.httpPost(`workspaces/${workspaceId}/bpmn/`, formData)
    }

    async [GRAPH_API_TYPE.SHARE_GRAPH]({graphId, data}) {
        return await this.httpPost(`graphs/${graphId}/share/`, data)
    }

    async [GRAPH_API_TYPE.MOVE_GRAPHS](data) {
        return await this.httpPost(`graphs/move/`, data)
    }

    async [GRAPH_API_TYPE.GET_GRAPH_ORDER]({workspaceId}) {
        return await this.httpGet(`workspaces/${workspaceId}/graphs/order/`)
    }

    async [GRAPH_API_TYPE.UPDATE_GRAPH_ORDER]({workspaceId, order}) {
        return await this.httpPost(`workspaces/${workspaceId}/graphs/order/`, {
            graph_order: order,
        })
    }

    async [GRAPH_API_TYPE.PREVIEW_ADHERENCE]({graphId, data}) {
        return await this.httpPost(`graphs/${graphId}/preview-adherence/`, data)
    }

    async [GRAPH_API_TYPE.PREVIEW_ADHERENCE_STATE]({graphId}) {
        return await this.httpGet(`graphs/${graphId}/preview-adherence/`)
    }

    async [GRAPH_API_TYPE.START_DISCOVERY](payload) {
        return await this.httpPost(`graphs/discovery/`, payload)
    }

    async [GRAPH_API_TYPE.GET_TRACES]({datamodelConfig}) {
        return await this.httpPost(`graphs/traces/`, {datamodel_config: datamodelConfig})
    }

    async [GRAPH_API_TYPE.START_ITDM_DISCOVERY](payload) {
        return await this.httpPost(`graphs/itdm_discovery/`, payload)
    }

    async [GRAPH_API_TYPE.START_TEST_DRIVEN_DISCOVERY](payload) {
        return await this.httpPost(`graphs/itdm_test_driven/`, payload)
    }
}

